import * as React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Slide,
  Typography,
} from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const UnlistedScreenerUnlock = ({
  isOpen,
  handleClose,
  handleConfirm,
  credits,
}) => {
  return (
    <>
      <Dialog
        open={isOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-handle-confirm"
        PaperProps={{
          sx: {
            width: {
              xs: '370px',
              sm: '370px',
              md: '499px',
              lg: '820px',
              xl: '820px',
            },
            maxWidth: '627px !important',
          },
        }}
      >
        <DialogTitle>
          <>
            <Grid
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
            >
              <Grid item>
                <Box className="control-row">
                  <Typography
                    sx={{
                      display: 'inline',
                      justifyContent: 'left',
                      // marginTop: '10px',
                      fontSize: { xs: '16px', md: '16px' },
                      fontWeight: '700',
                      color: '#717889',
                    }}
                  >
                    🌟 Your Credits Balance
                  </Typography>
                </Box>
              </Grid>
              <Grid item>
                <IconButton
                  aria-label="close"
                  onClick={handleClose}
                  color="primary"
                  disableRipple={true}
                >
                  <CloseSharpIcon />
                </IconButton>
              </Grid>
            </Grid>
          </>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'left',
              justifyContent: 'center',
            }}
          >
            <Typography sx={{ paddingY: '12px', color: ' #717889' }}>
              Hello there! 👋
            </Typography>
            <Typography sx={{ paddingTop: '12px', color: ' #717889' }}>
              You currently have{' '}
              <span style={{ color: '#0F9764' }}>
                {credits} {credits === 1 ? 'credit' : 'credits'}{' '}
              </span>
              available in your account.
            </Typography>
            <Typography sx={{ paddingBottom: '12px', color: ' #717889' }}>
              Just a friendly reminder: Unlocking a company requires only{' '}
              <span style={{ color: '#0F9764' }}>1 Credit</span>. Go ahead and
              explore the opportunities awaiting you!
            </Typography>
            <Typography sx={{ paddingTop: '12px', color: '#717889' }}>
              ✨ Happy Exploring! ✨
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={{ marginTop: '0px' }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
            }}
          >
            <Button
              variant="outlined"
              onClick={handleClose}
              sx={{ margin: '12px', borderRadius: '8px' }}
            >
              Later
            </Button>
            <Button
              variant="contained"
              sx={{ margin: '12px', borderRadius: '8px' }}
              onClick={handleConfirm}
            >
              Unlock
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UnlistedScreenerUnlock;
